import localStorageObject from './localStorage';

export default localStorageObject;
